
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/members.reducers';

export const selectDataState = createFeatureSelector<State>('memberData');

export const selectMemberData = createSelector(selectDataState, (state) => state.memberData);
export const selectMemberLoading = createSelector(selectDataState, (state) => state.loading);
export const selectMemberError = createSelector(selectDataState, (state) => state.error);
